import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Facade from "@/Facade";

export default class LoadingState extends BaseState {

  begin() {
    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    Signals.loadAssets.dispatch()
  }

  onContinueBtnClick() {
    this.end()
  }

  end = () => {
    this.stateMachine.setState(Facade.initialState)
  }

  cleanUp() {
    Signals.continueBtnClick.remove(this.onContinueBtnClick, this)
  }

}
